import { createOption, DATE_RANGE_OPTIONS } from "components/Common/DateRangePicker"
import { COMPARISON_FIELD_OPTIONS, FILTER_COMPONENT_TYPES, REPORTING_TIMEZONE } from "helpers/sf_constants"
import { getIANATimezoneStringForAbbreviation } from "helpers/sf_utils"
import { LEAD_INTEGRATION_PHASE } from "pages/integrations/integration-components/connector/Connector"

export const ADMIN_INTEGRATION_LOGS_FILTERS = {
    RECEIVED: 'received',
    ACCOUNT_ID: "account_id",
    ACCOUNT_NAME: "account_name",
    INTEGRATION_NAME: "integration_name",
    INTEGRATION_TYPE: "integration_type",
    TOTAL_REQUESTS: "total_requests",
    SUCCESSFUL_REQUESTS: "successful_requests",
    SUCCESS_RATE: "success_rate",
}

//Special cases where we need to pass selected_value as one more attribute
export const ADMIN_INTEGRATION_LOGS_FILTER_SPECIAL_CASES = [
    ADMIN_INTEGRATION_LOGS_FILTERS.TOTAL_REQUESTS,
    ADMIN_INTEGRATION_LOGS_FILTERS.SUCCESSFUL_REQUESTS,
    ADMIN_INTEGRATION_LOGS_FILTERS.SUCCESS_RATE,
    ADMIN_INTEGRATION_LOGS_FILTERS.ACCOUNT_ID
]

export const ADMIN_INTEGRATION_TYPE_OPTIONS = [
    { label: 'Pre-Ping', value: LEAD_INTEGRATION_PHASE.PRE_PING },
    { label: 'Ping', value: LEAD_INTEGRATION_PHASE.PING },
    { label: 'Post', value: LEAD_INTEGRATION_PHASE.POST },
    { label: 'Pre-fill', value: LEAD_INTEGRATION_PHASE.PRE_FILL },
    { label: 'Accept-Reject', value: LEAD_INTEGRATION_PHASE.ACCEPT_REJECT },
    { label: 'Direct Post', value: LEAD_INTEGRATION_PHASE.DIRECT_POST }
]
export const ADMIN_INTEGRATION_LOGS_FILTER_OBJECTS = {
    [ADMIN_INTEGRATION_LOGS_FILTERS.RECEIVED]: {
        order: 0,
        comparator_value: "",
        value: "",
        label: "Received",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.RECEIVED, // "received",
        component_type: FILTER_COMPONENT_TYPES.DATE_RANGE
    },
    [ADMIN_INTEGRATION_LOGS_FILTERS.ACCOUNT_ID]: {
        order: 1,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Account ID",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.ACCOUNT_ID,
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS,
    },
    [ADMIN_INTEGRATION_LOGS_FILTERS.INTEGRATION_NAME]: {
        order: 2,
        comparator_value: "",
        value: "",
        label: "Integration Name",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.INTEGRATION_NAME,
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT
    },

    [ADMIN_INTEGRATION_LOGS_FILTERS.INTEGRATION_TYPE]: {
        order: 3,
        comparator_value: "",
        value: "",
        label: "Integration Type",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.INTEGRATION_TYPE,
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT,
        options: ADMIN_INTEGRATION_TYPE_OPTIONS,
    },

    [ADMIN_INTEGRATION_LOGS_FILTERS.TOTAL_REQUESTS]: {
        order: 4,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Total Requests",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.TOTAL_REQUESTS,
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS,
    },

    [ADMIN_INTEGRATION_LOGS_FILTERS.SUCCESSFUL_REQUESTS]: {
        order: 5,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Successful Requests",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.SUCCESSFUL_REQUESTS,
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS,
    },

    [ADMIN_INTEGRATION_LOGS_FILTERS.SUCCESS_RATE]: {
        order: 6,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Success Rate",
        name: ADMIN_INTEGRATION_LOGS_FILTERS.SUCCESS_RATE,
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS,
        suffix: " %"
    }
}

const dateRangeOptions =
    createOption(
        DATE_RANGE_OPTIONS.THIS_MONTH,
        new Date(),
        getIANATimezoneStringForAbbreviation(REPORTING_TIMEZONE)
    )

const startDate = dateRangeOptions?.value?.startDate;
const endDate = dateRangeOptions?.value?.endDate;

export const DEFAULT_THIS_MONTH_FILTER = [
    {
        "order": 8,
        "comparator_value": "",
        "value": {
            "label": `This Month: ${startDate?.toLocaleDateString()} - ${endDate?.toLocaleDateString()}`,
            "value": {
                "startDate": startDate?.toISOString(),
                "endDate": endDate?.toISOString()
            },
            "original_label": "THIS_MONTH",
            "ianaTz": "America/Los_Angeles"
        },
        "label": "Received",
        "name": "received",
        "component_type": "date_range",
        "is_active": true
    }
]